import React, { Component } from "react";
import ReportHeader from "../../../Report/ReportHeader";
import axios from "axios";
import Spinner from "../../../Common/Spinner";
import * as appConst from "../../../Common/constants";
import moment from "moment";

class PatientCount extends Component {
  constructor(props) {
    super(props);

    this.state = {
      patients: [],
      spinnerClass: "",
      dataClass: "collapse"
    };
  }

  componentDidMount() {
    axios
      .post(
        (process.env.NODE_ENV !== "development"
          ? appConst.API_URL_PROD
          : appConst.API_URL_DEV) +
        "/patient/countReport",
        this.props.data
      )
      .then(response => {
        this.setState({
          patients: response.data,
          spinnerClass: "collapse",
          dataClass: ""
        });
      })
      .catch(function (error) {
        console.log(error);
      });
  }

  tabHeader() {
    return (
      <tr>
        <th className="border p-1 font-weight-bold" width="200px">Date</th>
        <th className="border p-1 font-weight-bold" width="200px">New</th>
        <th className="border p-1 font-weight-bold" width="200px">Follow-up</th>
        <th className="border p-1 font-weight-bold" width="200px">Total</th>
      </tr>
    );
  }

  dateFormatter(params) {
    if (params.value !== null) {
      var arr = params.value.split("-");
      return arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];
    }
  }

  tabRow() {
    if (this.state.patients.DailyCount !== undefined) {
      return this.state.patients.DailyCount.map(function (obj) {

        var arr = obj.date.split("-");
        var displayDate = arr[2].substring(0, 2) + "-" + arr[1] + "-" + arr[0];

        return (
          <tr key={obj.date}>
            <td className="border p-1">{displayDate}</td>
            <td className="border p-1" align="right">{obj.newCount}</td>
            <td className="border p-1" align="right">{obj.followup}</td>
            <td className="border p-1" align="right">{obj.total}</td>
          </tr>
        );
      });
    }
  }

  tabFooterRow() {
    if (this.state.patients.TotalCount !== undefined) {
      return (
        <tr key="Total">
          <td className="border p-1 font-weight-bold">Total</td>
          <td className="border p-1 font-weight-bold" align="right">{this.state.patients.TotalCount.newCount}</td>
          <td className="border p-1 font-weight-bold" align="right">{this.state.patients.TotalCount.followup}</td>
          <td className="border p-1 font-weight-bold" align="right">{this.state.patients.TotalCount.total}</td>
        </tr>
      );
    }
  }

  DisplayFilter() {
    return moment(this.props.data.fromDate).format("MMM-YYYY");
  }

  render() {
    return (
      <div>
        <ReportHeader onCloseClick={this.onCloseClick} IsClose="1" />
        <h3 align="center">Count Report - {this.DisplayFilter()}</h3>
        <div className={this.state.spinnerClass}>
          <Spinner />
        </div>

        <div className={this.state.dataClass}>
          <div className="container-fluid reportFont">
            <table>
              <thead>{this.tabHeader()}</thead>
              <tbody>{this.tabRow()}</tbody>
              <thead>{this.tabFooterRow()}</thead>
            </table>
          </div>
        </div>
      </div>
    );
  }

  onCloseClick = e => {
    this.props.onCloseClick("Filter", null);
  };
}

export default PatientCount;
